import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../store/store";
import { TChildren } from "./landing";

const LoginRefresher = ({ children }: TChildren) => {
  const { isLoggedIn, hasPCTokenExpired, isInPCLogin } = useSelector(
    (state: RootState) => state.user
  );
  const navigate = useNavigate();
  const isWaitingForSilentLogin = useRef<boolean>(false);
  useEffect(() => {
    if (hasPCTokenExpired) isWaitingForSilentLogin.current = true;
    if (isWaitingForSilentLogin.current && !hasPCTokenExpired && !isInPCLogin) {
      isWaitingForSilentLogin.current = false;
      navigate(0);
    }
  }, [hasPCTokenExpired, isLoggedIn, isInPCLogin]);
  return <>{children}</>;
};
export default LoginRefresher;
